module.exports = __webpack_public_path__ + "assets/img/6移仓.72dd961c.png";